"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var ContentSidebarViewStore_1 = require("./ContentSidebarViewStore");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var DropzonesStore_1 = require("Project/BlockNew/SavedBlockDropzone/DropzonesStore");
var SidebarImageViewStore_1 = require("./Images/SidebarImageViewStore/SidebarImageViewStore");
var RecentlyUsedDataStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/RecentlyUsed/RecentlyUsedDataStore"));
var UploadsDataStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/Uploads/UploadsDataStore"));
var UnsplashDataStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/Unsplash/UnsplashDataStore"));
var ImageLibraryDataStore_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryDataStore");
var pages_common_1 = require("@qwilr/pages-common");
var ContentSidebarToggleTab_1 = require("./ContentSidebarToggleTab");
var styles = __importStar(require("./ContentSidebar.css"));
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var SidebarLibrary_1 = __importStar(require("./Library/SidebarLibrary"));
var SidebarExplore_1 = require("./Explore/SidebarExplore");
var ContentSidebarHeader_1 = require("./ContentSidebarHeader");
var ContentSidebarLibraryViewStore_1 = require("./Library/ContentSidebarLibraryViewStore");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var Promptable_1 = require("Common/Prompt/Promptable");
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var moment_1 = __importDefault(require("moment"));
var ImageLibraryUtils_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryUtils");
var Types_1 = require("@CommonFrontendBackend/Folders/Types");
var DuplicateUploadNotifier_1 = require("Common/Upload/DuplicateUploadNotifier");
exports.BASE_CLASS_NAME = "content-sidebar";
var ContentSidebar = (function (_super) {
    __extends(ContentSidebar, _super);
    function ContentSidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.onNavDrawerToggleDisposer = null;
        _this.onDragOver = function (event) {
            if (_this.props.dragStore.findDragItemFromCurrentDrag(DragStore_1.DragType.SavedBlock)) {
                event.stopPropagation();
            }
        };
        _this.handleOpenImageLibrary = function () {
            _this.props.assetLibraryOverlay.launchCustomOverlay(function (mediaSource, data, metricSource) {
                _this.props.clickToAddStore.clickToAdd({
                    mediaData: data,
                    mediaSource: mediaSource,
                    telemetryData: {
                        source: metricSource,
                    },
                });
            }, { earlyExit: true, startingFolder: _this.sidebarImageViewStore.currentFolder }, {
                onClose: function () {
                    _this.sidebarImageViewStore.clearUploadIds();
                },
            });
        };
        _this.handleUploadAndTabChange = function () {
            _this.onUpload();
            _this.props.contentSidebarViewStore.setView(ContentSidebarViewStore_1.SidebarView.Library);
            _this.props.contentSidebarLibraryViewStore.setCurrentTab(ContentSidebarLibraryViewStore_1.ContentSidebarTab.Image);
        };
        _this.handleOpenImageLibAndTabChange = function () {
            _this.handleOpenImageLibrary();
            _this.props.contentSidebarViewStore.setView(ContentSidebarViewStore_1.SidebarView.Library);
            _this.props.contentSidebarLibraryViewStore.setCurrentTab(ContentSidebarLibraryViewStore_1.ContentSidebarTab.Image);
        };
        _this.onUpload = function () {
            if (!_this.fileInputRef.current || !_this.fileInputRef.current.files) {
                return;
            }
            var file = _this.fileInputRef.current.files[0];
            if (!file) {
                return;
            }
            if (!(0, ImageLibraryUtils_1.isAnUploadsFolder)(_this.sidebarImageViewStore.currentFolder)) {
                _this.sidebarImageViewStore.selectFolder(Types_1.ImageLibrarySystemFolder.Uploads);
            }
            var uploadFolderId = (0, ImageLibraryUtils_1.toApiFolderId)(_this.sidebarImageViewStore.currentFolder);
            var uploadId = _this.props.uploadStore.upload(file, { folderId: uploadFolderId });
            _this.duplicateUploadNotifier.notifyOnDuplicateUpload(uploadId);
            _this.sidebarImageViewStore.addUploadId(uploadId);
        };
        var imageServices = props.imageServices, disableImgix = props.disableImgix, imageFolderViewStore = props.imageFolderViewStore;
        var recentlyUsedDataStore = new RecentlyUsedDataStore_1.default(imageServices.recentlyUsedService);
        var uploadsDataStore = new UploadsDataStore_1.default(imageServices.uploadsService, imageServices.imageResourceApiService, disableImgix);
        var unsplashDataStore = new UnsplashDataStore_1.default(imageServices.unsplashImageService, imageServices.stockImageService);
        _this.imageLibraryDataStore = new ImageLibraryDataStore_1.ImageLibraryDataStore([
            unsplashDataStore,
            recentlyUsedDataStore,
            uploadsDataStore,
        ]);
        _this.imageLibraryDataStore.selectFolder(imageFolderViewStore.folderSelectionStore.selectedFolder);
        _this.sidebarImageViewStore = new SidebarImageViewStore_1.SidebarImageViewStore(_this.imageLibraryDataStore, function () {
            props.telemetry.trackOnly("Sidebar Assets Searched", {
                source_tab: "your_library",
                source_secondary_tab: "images",
            }, {
                blockIntercom: true,
            });
        }, imageFolderViewStore);
        _this.fileInputRef = react_1.default.createRef();
        _this.duplicateUploadNotifier = new DuplicateUploadNotifier_1.DuplicateUploadNotifier(_this.props.notifyUser, imageFolderViewStore, _this.props.uploadStore);
        return _this;
    }
    ContentSidebar.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var savedView, openLocation, savedState, shouldOpenOnMount;
            var _this = this;
            return __generator(this, function (_a) {
                savedView = this.props.contentSidebarViewStore.savedView;
                openLocation = savedView === ContentSidebarViewStore_1.SidebarView.Library
                    ? { view: ContentSidebarViewStore_1.SidebarView.Library, tab: ContentSidebarLibraryViewStore_1.ContentSidebarTab.Blocks }
                    : { view: ContentSidebarViewStore_1.SidebarView.Explore };
                savedState = window.localStorage.getItem(ContentSidebarViewStore_1.sidebarLocalStorageKey);
                shouldOpenOnMount = savedState ? savedState === "open" : true;
                if (shouldOpenOnMount) {
                    this.props.contentSidebarViewStore.open(TelemetryEnums_1.SidebarOpenOrigin.LibraryButton, openLocation);
                }
                this.onNavDrawerToggleDisposer = pages_common_1.PubSub.subscribe("qwilr:nav-drawer-toggled", function (_a) {
                    var isOpen = _a.isOpen;
                    if (isOpen && _this.props.contentSidebarViewStore.isOpen) {
                        _this.props.contentSidebarViewStore.close();
                    }
                });
                return [2];
            });
        });
    };
    ContentSidebar.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.onNavDrawerToggleDisposer) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    ContentSidebar.prototype.onDragEnter = function () {
        var dropzonesStore = this.props.dropzonesStore;
        if (!dropzonesStore.isPersistent && dropzonesStore.currentDropzone.status === DropzonesStore_1.CurrentDropzoneState.Active) {
            dropzonesStore.clearActiveDropzone();
        }
        else if (dropzonesStore.isPersistent) {
            dropzonesStore.setCurrentDropzone(dropzonesStore.currentDropzone.index, DropzonesStore_1.CurrentDropzoneState.Idle);
        }
    };
    ContentSidebar.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, contentSidebarViewStore = _b.contentSidebarViewStore, dragStore = _b.dragStore, contentSidebarLibraryViewStore = _b.contentSidebarLibraryViewStore, isTrialUser = _b.isTrialUser, userCreatedAt = _b.userCreatedAt;
        var releaseDate = (0, moment_1.default)("2024-09-02T00:50:00.000Z");
        var isExistingUser = (0, moment_1.default)(userCreatedAt).isBefore(releaseDate);
        var shouldShowPrompt = !isTrialUser && isExistingUser && contentSidebarViewStore.isOpen;
        return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)([
                    exports.BASE_CLASS_NAME,
                    (_a = {},
                        _a["".concat(exports.BASE_CLASS_NAME, "--open")] = contentSidebarViewStore.isOpen,
                        _a["".concat(exports.BASE_CLASS_NAME, "--has-tabs")] = this.props.sidebarImagesEnabled,
                        _a["".concat(exports.BASE_CLASS_NAME, "--with-folders")] = contentSidebarLibraryViewStore.isShowingFolders,
                        _a["".concat(exports.BASE_CLASS_NAME, "--is-dragging")] = dragStore.isDragging,
                        _a),
                ]), onDragEnter: this.onDragEnter.bind(this), onDragOver: this.onDragOver, onMouseEnter: this.props.contentSidebarLibraryViewStore.hidePrompt },
                react_1.default.createElement("div", { className: (0, classnames_1.default)("content-sidebar__inner", styles.sidebarInner({
                        withFoldersOffset: this.props.contentSidebarViewStore.view === ContentSidebarViewStore_1.SidebarView.Library ||
                            !this.props.contentSidebarViewStore.isOpen,
                    })) },
                    this.props.contentSidebarViewStore.view === ContentSidebarViewStore_1.SidebarView.Library && (react_1.default.createElement(SidebarLibrary_1.SidebarLibraryFolders, { contentSidebarLibraryViewStore: this.props.contentSidebarLibraryViewStore, savedBlocksFolderViewStore: this.props.savedBlocksFolderViewStore, imageFolderViewStore: this.props.imageFolderViewStore, savedBlockViewStore: this.props.savedBlockViewStore, sidebarImageViewStore: this.sidebarImageViewStore })),
                    react_1.default.createElement(kaleidoscope_1.Stack, null,
                        react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "l", paddingTop: "l", paddingRight: "l", gap: "m", className: styles.sidebarHeader },
                            react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Library source", labelHidden: true, onClickHandler: function (value) {
                                    _this.props.contentSidebarLibraryViewStore.hideFolders();
                                    _this.props.contentSidebarViewStore.setView(value);
                                }, options: [
                                    {
                                        label: (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                                                if (shouldShowPrompt) {
                                                    return react_1.default.createElement(Promptable_1.Promptable, { id: PromptTypes_1.PromptId.ContentSidebarExploreTab }, children);
                                                }
                                                return children;
                                            } },
                                            react_1.default.createElement(ContentSidebarHeader_1.SidebarSegmentButton, { iconComponent: icons_1.Library, label: "Your Library", selected: this.props.contentSidebarViewStore.view === ContentSidebarViewStore_1.SidebarView.Library }))),
                                        value: ContentSidebarViewStore_1.SidebarView.Library,
                                    },
                                    {
                                        label: (react_1.default.createElement(ContentSidebarHeader_1.SidebarSegmentButton, { iconComponent: icons_1.Explore, label: "Explore", selected: this.props.contentSidebarViewStore.view === ContentSidebarViewStore_1.SidebarView.Explore })),
                                        value: ContentSidebarViewStore_1.SidebarView.Explore,
                                    },
                                ], selectedValue: this.props.contentSidebarViewStore.view })),
                        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", className: styles.sidebarViewContainer },
                            this.props.contentSidebarViewStore.view === ContentSidebarViewStore_1.SidebarView.Library && (react_1.default.createElement(SidebarLibrary_1.default, { accountId: this.props.accountId, contentSidebarViewStore: this.props.contentSidebarViewStore, contentSidebarLibraryViewStore: this.props.contentSidebarLibraryViewStore, savedBlockViewStore: this.props.savedBlockViewStore, dragStore: this.props.dragStore, dropzonesStore: this.props.dropzonesStore, thumbnailBaseUrl: this.props.thumbnailBaseUrl, savedBlockOpener: this.props.savedBlockOpener, telemetry: this.props.telemetry, userIsAdmin: this.props.userIsAdmin, useHistoryDataStore: this.props.useHistoryDataStore, sidebarImagesEnabled: this.props.sidebarImagesEnabled, canEditQuoteV1: this.props.canEditQuoteV1, savedBlocksFolderViewStore: this.props.savedBlocksFolderViewStore, imageFolderViewStore: this.props.imageFolderViewStore, imageServices: this.props.imageServices, disableImgix: this.props.disableImgix, clickToAddStore: this.props.clickToAddStore, uploadStore: this.props.uploadStore, dropLocationStore: this.props.dropLocationStore, notifyUser: this.props.notifyUser, usingFeature: this.props.usingFeature, imageLibraryDataStore: this.imageLibraryDataStore, sidebarImageViewStore: this.sidebarImageViewStore, fileInputRef: this.fileInputRef, duplicateUploadNotifier: this.duplicateUploadNotifier, onUpload: this.onUpload, handleOpenImageLibrary: this.handleOpenImageLibrary })),
                            this.props.contentSidebarViewStore.view === ContentSidebarViewStore_1.SidebarView.Explore && (react_1.default.createElement(SidebarExplore_1.SidebarExplore, { openImageLibrary: this.handleOpenImageLibAndTabChange, fileInputRef: this.fileInputRef, onUpload: this.handleUploadAndTabChange }))))),
                react_1.default.createElement(ContentSidebarToggleTab_1.ToggleTab, null))));
    };
    ContentSidebar = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ContentSidebar);
    return ContentSidebar;
}(react_1.default.Component));
exports.default = ContentSidebar;
